import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

export interface IProps {
  currentYear: number
  currentMonth: number
  showYear: number
  monthClickhandler: (month: number) => Promise<void>
  yearClickhandler: (year: number) => void
}

export const YearMonthFilter = (props: IProps): JSX.Element => {
  return (
    <div className={Style.wrapper}>
      <div className={Style.FilterYear}>
        <div className={Style.FilterYearItemPrev}>
          <a
            className={Style.FilterYearItemPrevLink}
            onClick={() => props.yearClickhandler(props.showYear - 1)}
          >
            <i className="fa fa-chevron-left"></i>
          </a>
        </div>
        <div className={Style.FilterYearItemCurrent}>
          {props.showYear}
          <span className={Style.FilterYearItemCurrentUnit}>年</span>
        </div>
        <div className={Style.FilterYearItemNext}>
          <a
            className={Style.FilterYearItemNextLink}
            onClick={() => props.yearClickhandler(props.showYear + 1)}
          >
            <i className="fa fa-chevron-right"></i>
          </a>
        </div>
      </div>
      <ul className={Style.FilterMonth}>
        {[...Array<null>(12)].map((_, i) => (
          <li
            className={Style.FilterMonthItem}
            key={`${props.showYear}${i + 1}`}
          >
            <a
              className={classNames({
                [Style.FilterMonthItemLink]: true,
                [Style.FilterMonthItemLinkActive]:
                  i + 1 === props.currentMonth &&
                  props.showYear === props.currentYear,
              })}
              onClick={() => void props.monthClickhandler(i + 1)}
            >
              {i + 1}月
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default YearMonthFilter
